import React from 'react';
import c from 'classnames';
import s from './VerticalLayout.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const VerticalLayout: React.FC<Props> = ({ children, className }) => (
  <div className={c(s['root'], className)}>{children}</div>
);

VerticalLayout.displayName = 'VerticalLayout';

export default VerticalLayout;
